import { Link } from "react-router-dom";
import { ArrowLeft, Monitor } from "lucide-react";
import { PrototypeBadge } from "@/components/common/PrototypeBadge";
import { useFramed } from "@/components/layout/DeviceFrame";

export const InstallerShell = ({ title, back, children, action }) => {
  const framed = useFramed();
  return (
  <div className={`${framed ? "min-h-full" : "min-h-screen"} bg-background`} data-testid="installer-shell">
    <header className="sticky top-0 z-40 border-b bg-background">
      <div className="mx-auto flex h-14 max-w-xl items-center justify-between px-3">
        <div className="flex min-w-0 items-center gap-1">
          {back && <Link to={back} className="flex h-11 w-11 items-center justify-center rounded-md transition-colors hover:bg-secondary active:bg-secondary" aria-label="Tilbake" data-testid="installer-back"><ArrowLeft className="h-5 w-5" /></Link>}
          <div className={`flex min-w-0 items-center gap-2.5 ${back ? "" : "pl-1"}`}>
            {!back && <img src="/trapperingen-logo.svg" alt="Trapperingen" className="h-7 w-auto shrink-0" draggable="false" />}
            <div className="min-w-0 leading-tight"><p className="text-[13px] font-semibold">B. Innvær</p><p className="truncate t-meta">{title}</p></div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {action}
          {!framed && <Link to="/oversikt" className="hidden items-center gap-1 rounded-md px-2 py-1 text-[12.5px] text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground sm:flex" data-testid="installer-to-desktop"><Monitor className="h-3.5 w-3.5" /> Kontorvisning</Link>}
        </div>
      </div>
    </header>
    <main className="mx-auto max-w-xl px-4 pb-32 pt-4">{children}</main>
    <footer className="mx-auto flex max-w-xl flex-col items-center gap-1 px-4 pb-8 text-center"><PrototypeBadge /><p className="text-[12px] text-muted-foreground">Utviklet av Kviteberg</p></footer>
  </div>
  );
};
